import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
// import axios from 'axios'
import VueOnsen from 'vue-onsenui'
import VueScrollTo from 'vue-scrollto'
import VueGtag from 'vue-gtag'

// NOTE: createjsを読み込む
const createjs = require('createjs')

Vue.use(VueOnsen)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

Vue.use(VueGtag,
	{
		config: {
			id: process.env.VUE_APP_GA_ID,
			params: {
				send_page_view: false // ページビューの自動送信を無効
			}
		}
	}
)

new Vue({
	router,
	store,
	createjs,
	render: h => h(App)
}).$mount('#app')
